<template>
  <div class="home-releases-component overflow-hidden">
    <div
      class="release-card position-relative py-lg-0 p-3"
      :style="releaseStyleCard"
    >
      <div class="responsive-image d-lg-none" :style="styleBg">
        <img
          v-if="!release.cover"
          class="img-partner-placeholder"
          :src="$setup.partnerLogo"
        />
      </div>
      <div class="row image-container">
        <div class="col-lg-2">
          <div class="date-container">
            <div class="day-month">
              <p class="day pr-2">{{ day }}</p>
              <p class="month pl-lg-1">{{ month }}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 py-lg-4 m-lg-0">
          <div class="d-flex flex-column h-100">
            <div class="next-releases" :style="releaseStyle">
              PRÓXIMOS LANÇAMENTOS
            </div>
            <div class="title">{{ release.title }}</div>
            <div class="flex-fill d-none d-lg-block">
              <div class="pt-3 description" :s4yle="releaseStyle">
                {{ release.description }}
              </div>
            </div>
            <div class="d-none d-lg-flex align-items-center">
              <button class="btn-info btn mr-lg-3" @click="goToLink">
                Saber mais
              </button>
              <button
                v-if="notification"
                class="btn btn-notice d-flex align-items-center px-3"
                :style="releaseStyleButton"
              >
                <i class="pr-2 icon-check"></i>
                Aviso enviado
              </button>
              <button
                v-else
                class="btn btn-notice d-flex align-items-center px-4"
                :style="releaseStyleButton"
                @click="modal = true"
              >
                <i class="pr-2 icon-notification"></i>
                Receber aviso
              </button>
            </div>
            <div class="d-lg-none">
              <div class="pt-4 description mb-4" :style="releaseStyle">
                {{ release.description }}
              </div>
              <button class="btn-info btn btn-block" @click="goToLink">
                Saber mais
              </button>
              <button
                v-if="notification"
                class="btn btn-notice btn-block"
                :style="releaseStyleButton"
              >
                <i class="pr-2 icon-check"></i>
                Aviso enviado
              </button>
              <button
                v-else
                class="btn btn-notice btn-block"
                :style="releaseStyleButton"
                @click="modal = true"
              >
                <i class="pr-2 icon-notification"></i>
                Receber aviso
              </button>
            </div>
          </div>
        </div>
        <div class="img col-lg-4 d-none d-lg-block" :style="styleBg">
          <img
            v-if="!release.cover"
            class="img-partner-placeholder"
            :src="$setup.partnerLogo"
          />
        </div>
        <releases-modal v-model="modal" :release="release" />
      </div>
    </div>
  </div>
</template>

<script>
import ReleasesModal from "@/components/home/ReleasesModal.vue";
import get from "lodash/get";

export default {
  components: { ReleasesModal },
  props: {
    release: Object
  },
  data() {
    let hasNotification =
      get(this.release, "notification.status") === "enabled";
    return {
      modal: false,
      notification: hasNotification
    };
  },
  computed: {
    styleBg() {
      if (this.release.cover) {
        return `background-image: url(${this.release.cover})`;
      }

      return "";
    },
    releaseStyleCard() {
      const releaseCard =
        this.$setup.theme === "dark"
          ? "linear-gradient(to top right, #0c0d13 0%, #0c0d13 44.14%, #212536 70%)"
          : "#ffffff";
      return {
        background: releaseCard
      };
    },
    releaseStyle() {
      const release = this.$setup.theme === "dark" ? "#bebfc7" : "#77788E";
      return {
        color: release
      };
    },
    releaseStyleButton() {
      const releaseButton =
        this.$setup.theme === "dark"
          ? {
              color: "#bebfc7",
              border: "1px solid #bebfc7"
            }
          : {
              color: "#6B6E73",
              border: "1px solid #6B6E73"
            };
      return releaseButton;
    },
    day() {
      let date = new Date(this.release.release_at);
      return date.getDate();
    },
    month() {
      let date = new Date(this.release.release_at);
      let month = date.getMonth();
      const monthName = {
        0: "JAN",
        1: "FEV",
        2: "MAR",
        3: "ABR",
        4: "MAI",
        5: "JUN",
        6: "JUL",
        7: "AGO",
        8: "SET",
        9: "OUT",
        10: "NOV",
        11: "DEC"
      };
      return monthName[month];
    }
  },
  methods: {
    goToLink() {
      if (this.release.url) document.location.href = this.release.url;
    }
  }
};
</script>

<style lang="scss" scoped>
.home-releases-component {
  .responsive-image {
    position: absolute;
    width: 100%;
    height: 38%;
    left: 0;
    top: 0;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    border-radius: 8px 8px 0 0;
  }

  .next-releases {
    color: #bebfc7;
    font-size: 14px;
    font-weight: 600;
  }

  @media screen and (min-width: 992px) {
    .date-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }

  .day {
    height: 68px;
    font-size: 70px;
    @media screen and (max-width: 991px) {
      font-size: 14px;
    }
  }

  .month {
    font-weight: 600;
    font-size: 22px;
    @media screen and (max-width: 991px) {
      font-size: 14px;
    }
  }

  .title {
    font-size: 24px;
    font-weight: 500;
    @media screen and (max-width: 991px) {
      font-size: 14px;
    }
  }

  .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    @media screen and (max-width: 991px) {
      height: 80px;
      font-size: 12px;
    }
  }

  .btn-info {
    border-radius: 8px;
    background: #3e56ac;
    border: none;
    font-size: 16px;
  }

  .btn-notice {
    border-radius: 8px;
    font-size: 16px;
  }

  .img {
    height: 320px;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    border-radius: 0 8px 8px 0;
    position: relative;

    .img-partner-placeholder {
      max-width: 48px;
      max-height: 48px;
      min-width: 48px;
      min-height: 48px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .icon-notification,
  .icon-check {
    font-size: 24px;
  }

  .release-card {
    width: 100%;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  @media screen and (max-width: 991px) {
    .image-container {
      padding-top: 220px;
    }

    .day-month {
      flex-direction: row;
      display: flex;
      height: 75px;
      padding-top: 30px;
    }

    .day {
      font-size: 24px;
      font-weight: 500;
    }

    .month {
      font-weight: 600;
      font-size: 22px;
    }
  }
}
</style>
